import styled from "styled-components/macro"

export const MainContainer = styled.div`
  width: 100%;
  margin: 0 auto;

  @media (min-width: 640px) {
    width: 640px;
    margin: 0 auto;
  }

  @media (min-width: 768px) {
    width: 768px;
    padding: 0 16px;
  }

  @media (min-width: 1024px) {
    width: 1024px;
  }

  @media (min-width: 1280px) {
    width: 1280px;
  }
`
